import React, {Component} from 'react';
import { animateScroll as scroll } from 'react-scroll';
import { Link } from "react-router-dom"

const links = [
    { name: "About us", path: "/" },
    { name: "Our team", path: "/team" },
    { name: "Our services", path: "/services" },
    { name: "Completed Projects", path: "/completed-projects" }
]
class Footer extends Component{
    
    constructor(props){
        super(props);
        this.state = {};
        this.handleScroll = this.handleScroll.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
    }

    handleScroll() {
        if(this.mount){
            this.setState({scroll: window.scrollY});
        }
    }

    scrollToTop (){
        scroll.scrollToTop();
    }
  
    componentDidMount() {
        this.mount = true;
        const el = document.querySelector('nav');
        this.setState({top: el.offsetTop, height: el.offsetHeight});
        window.addEventListener('scroll', this.handleScroll);
    }
    
    componentDidUpdate() {
        this.state.scroll > this.state.top ? 
        document.getElementById("scroll-top").classList.add("show") :
        document.getElementById("scroll-top").classList.remove("show") ;
    }

    componentWillUnmount(){
        this.mount = false;
    }

    getCurrentYear = () => {
        return new Date().getFullYear();
    }

    render(){
        return(
            <div>
                <div className="footer-area grey-bg">
                    <div className="container">
                        <div className="row">
                        <div className="col-lg-12">
                            <div className="footer-content-wrapper section-space--inner--60">
                            <div className="row">
                                <div className="col-xl-4 col-lg-4 col-md-12">
                                <div className="footer-intro-wrapper">
                                    <div className="footer-logo">
                                        <Link to="/">
                                            <img src="/assets/img/logo/cienco-logo.png" className="img-fluid" alt="cienco-construction" />
                                        </Link>
                                    </div>
                                </div>
                                </div>

                                <div className="col-xl-2 offset-xl-2 offset-lg-2 col-lg-3 col-md-6">
                                <div className="footer-widget">
                                    <h4 className="footer-widget__title">USEFUL LINKS</h4>
                                    <ul className="footer-widget__navigation">
                                        {links.map((link, key) => <li key={key}><a href={link.path}>{link.name}</a></li>)}
                                    </ul>
                                </div>
                                </div>                               


                                <div className="col-xl-3 offset-xl-1 col-lg-3 col-md-6">
                                <div className="footer-widget mb-0">
                                    <h4 className="footer-widget__title">CONTACT US</h4>
                                    <div className="footer-widget__content">
                                    <p className="address">1st floor, N’orch Building, 170-170 Bis Bui Thi Xuan Street, District 1, Ho Chi Minh City, Vietnam</p>
                                    <ul className="contact-details">
                                        <li><span>P:</span>090 918 8029</li>
                                        <li><span>E:</span>info@ciencoconstruction.com</li>
                                    </ul>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>                    
                </div>
                <button className="scroll-top" id="scroll-top" onClick={this.scrollToTop}>
                    <i className="ion-android-arrow-up" />
                </button>
            </div>
        )
    }
}


export default Footer;